<template>
  <v-btn icon color="mainBlue" class="export-btn" @click="handleExport" small>
    <v-icon size="20">mdi-export</v-icon>
  </v-btn>
</template>

<script>
import { exportExcel } from "@/core/utils/export.utils";
import moment from "jalali-moment";
import { mapGetters } from "vuex";

export default {
  name: "HMIHistoryExport",

  props: {
    type: { type: String, required: true },
  },

  computed: {
    ...mapGetters(["HMIChartConfig", "HMIChartData"]),
    from() {
      return moment(this.HMIChartConfig.from).format("jYYYY-jMM-jDD");
    },
    to() {
      return moment(this.HMIChartConfig.to).format("jYYYY-jMM-jDD");
    },
    selectedParam() {
      return this.$t(this.HMIChartConfig.parameter);
    },
  },

  methods: {
    handleExport() {
      const title = `${this.selectedParam} ${this.type} results export from ${this.from} to ${this.to}`;
      const headers = ["interval", "time", "value"];
      const data = [];
      Object.entries(this.HMIChartData).forEach(([interval, chartData]) => {
        chartData.forEach(([time, value]) => {
          data.push({
            interval,
            time: moment(new Date(time)).format("jYYYY/jMM/jDD hh:mm"),
            value,
          });
        });
      });

      exportExcel({ title, headers, data });
    },
  },
};
</script>

<style lang="scss" scoped>
.export-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
